export default "__VITE_ASSET__CNu6L1Oo__";